import { forwardRef, useMemo } from "react";
import { FilterTagButton } from "../../../../components/buttons/FilterTag";
import { ComicUserReadingStatusEntity } from "../../../../services/gc/types";
import { Option } from "../../../../types";
import { FilterTitle } from "../../../../components/filters/FilterTitle";
import { RadioFilter } from "../../../../components/filters/RadioFilter";
import { COMIC_USER_READING_STATUS_ALL } from "../../../../components/readingStatusButton/constants";

interface ComicUserReadingStatusFilterProps {
  value?: string;
  comicUserReadingStatus: ComicUserReadingStatusEntity[];
  includeAll?: boolean;
  onChange?: (nextValue: string) => void;
}
export function ComicUserReadingStatusFilter({
  value,
  comicUserReadingStatus,
  includeAll = true,
  onChange,
}: ComicUserReadingStatusFilterProps) {
  const categoryOptions: Option<string>[] = useMemo(() => {
    const options = [
      ...comicUserReadingStatus.map((type) => ({
        label: type.display_name,
        value: "" + type.id,
      })),
    ];
    if (includeAll) {
      options.unshift({ label: "All", value: COMIC_USER_READING_STATUS_ALL });
    }
    return options;
  }, [comicUserReadingStatus]);

  return (
    <RadioFilter
      value={value}
      options={categoryOptions}
      onChange={onChange ? onChange : () => {}}
    />
  );
}

interface ComicUserReadingStatusFilterTitleProps {
  isTrigger: boolean;
  comicUserReadingStatuses: ComicUserReadingStatusEntity[];
  activeValue?: string;
  open: boolean;
}
export const ComicUserReadingStatusFilterTitle = forwardRef(
  (
    {
      isTrigger,
      comicUserReadingStatuses,
      activeValue,
      open,
      ...props
    }: ComicUserReadingStatusFilterTitleProps,
    ref,
  ) => {
    const comicUserReadingStatus = comicUserReadingStatuses.find(
      (status) => `${status.id}` == activeValue,
    );

    if (isTrigger) {
      return (
        <FilterTagButton
          popoverRef={ref}
          text="Reading Status"
          isFiltering={comicUserReadingStatus?.display_name}
          {...props}
        />
      );
    }
    return (
      <FilterTitle
        text="Reading Status"
        open={open}
      />
    );
  },
);
